import React from 'react';
import SEO from '../components/SEO';
import './StaticPage.css';

const DisclaimerPage = () => (
  <div className="static-page">
    <SEO
      title="Disclaimer"
      description="Disclaimer for SarkariNaukriRajasthan.com – information accuracy, external links policy, and terms of use."
      path="/disclaimer"
    />
    <h1 className="static-page-title">Disclaimer</h1>
    <p className="static-page-updated">Last updated: March 2, 2026</p>

    <section className="static-section">
      <h2>General Information</h2>
      <p>
        The information provided on <strong>SarkariNaukriRajasthan.com</strong> is for general
        informational purposes only. While we strive to keep the information accurate and up-to-date,
        we make no representations or warranties of any kind, express or implied, about the
        completeness, accuracy, reliability, or availability of the information contained on this website.
      </p>
    </section>

    <section className="static-section">
      <h2>Not an Official Government Website</h2>
      <p>
        SarkariNaukriRajasthan.com is <strong>not</strong> an official government website. We are a
        private informational portal that aggregates government job notifications from various official
        sources. We do not recruit, hire, or process any job applications. All job applications must
        be submitted through the respective official government portals.
      </p>
    </section>

    <section className="static-section">
      <h2>No Guarantee of Accuracy</h2>
      <p>
        Job details including vacancies, eligibility criteria, salary, important dates, and application
        links are sourced from official notifications. However, these details may change without prior
        notice. Candidates are strongly advised to verify all information from the official recruitment
        website or notification before applying.
      </p>
    </section>

    <section className="static-section">
      <h2>External Links</h2>
      <p>
        Our website contains links to external websites including official government portals,
        application forms, and result pages. These links are provided for convenience only. We have
        no control over the content, privacy policies, or practices of any third-party websites and
        accept no responsibility or liability for them.
      </p>
    </section>

    <section className="static-section">
      <h2>No Fee Charged</h2>
      <p>
        SarkariNaukriRajasthan.com does <strong>not</strong> charge any fee for providing job
        information. If anyone asks for money in the name of this website, please do not pay and
        report it to us immediately. Official application fees, if any, are paid directly to the
        respective government department through their official portal.
      </p>
    </section>

    <section className="static-section">
      <h2>Limitation of Liability</h2>
      <p>
        In no event shall SarkariNaukriRajasthan.com be liable for any loss or damage including,
        without limitation, indirect or consequential loss or damage, arising out of or in connection
        with the use of this website. Any reliance you place on the information is strictly at your own risk.
      </p>
    </section>

    <section className="static-section">
      <h2>Copyright</h2>
      <p>
        All content on this website, including text, design, and layout, is the property of
        SarkariNaukriRajasthan.com unless otherwise stated. Job notification content is sourced
        from public government notifications and is reproduced for informational purposes.
      </p>
    </section>

    <section className="static-section">
      <h2>Contact</h2>
      <p>
        If you believe any information on this website is inaccurate or if you have concerns,
        please contact us at{' '}
        <a href="mailto:sarkarinaukrirajasthanjobs@gmail.com">sarkarinaukrirajasthanjobs@gmail.com</a>
      </p>
    </section>
  </div>
);

export default DisclaimerPage;
